// GENERATED by scripts/ptpt_build_frontend.mjs — European Portuguese (pt-PT) overrides. Do not edit by hand.
export const ptPT = {
  "wiz.err_session": "A sua sessão expirou. Inicie sessão novamente para criar o seu Natal.", "wiz.err_generic": "Não foi possível criar o seu Natal: {msg}",
 "tagline": "O seu Natal. À sua maneira.",
 "nav.home": "Início",
 "nav.decoration": "Decoração",
 "nav.ceia": "A minha Ceia",
 "nav.recipes": "Receitas",
 "nav.table": "Mesa de Natal",
 "nav.shopping": "Lista de Compras",
 "nav.planner": "O meu Planeamento",
 "nav.gifts": "Presentes",
 "nav.moment": "Momento de Natal",
 "nav.favorites": "Favoritos",
 "nav.account": "A minha Conta",
 "nav.admin": "Administração",
 "cta.start": "Começar o meu Natal",
 "cta.login": "Entrar",
 "cta.logout": "Sair",
 "cta.register": "Criar conta",
 "cta.buy": "Quero preparar o meu Natal",
 "cta.see_ideas": "Ver ideias",
 "cta.see_recipes": "Ver receitas",
 "cta.back": "Voltar",
 "cta.save": "Guardar",
 "cta.add": "Adicionar",
 "cta.remove": "Remover",
 "cta.share": "Partilhar",
 "cta.add_to_list": "Adicionar ingredientes à minha lista",
 "cta.continue": "Continuar",
 "cta.explore": "Explorar",
 "landing.story1": "Todo Natal começa com uma ideia.",
 "landing.story2": "Uma árvore. Uma mesa. Uma receita. Uma família reunida.",
 "landing.story3": "Até que tudo se transforma numa lembrança.",
 "landing.intro": "Planeie a decoração, organize a sua ceia, descubra receitas incríveis, faça o seu amigo secreto e prepare cada detalhe para viver um Natal inesquecível.",
 "landing.subtitle": "Tudo o que precisa para preparar o seu Natal num só lugar.",
 "landing.benefits_title": "Tudo o que precisa, num só lugar",
 "landing.diff_title": "Um Natal que cabe no seu orçamento.",
 "landing.diff_text": "Informa quantas pessoas, quanto pretende gastar, o estilo e o país. A plataforma prepara recomendações sob medida para o seu Natal.",
 "landing.faq_title": "Perguntas frequentes",
 "auth.welcome": "Bem-vindo ao seu Natal.",
 "auth.welcome_sub": "Entre para continuar a preparar momentos inesquecíveis.",
 "auth.email": "E-mail",
 "auth.password": "Palavra-passe",
 "auth.name": "Nome",
 "auth.forgot": "Esqueci-me da palavra-passe",
 "auth.google": "Continuar com Google",
 "auth.no_account": "Não tem conta? Criar agora",
 "auth.have_account": "Já tem conta? Entrar",
 "auth.remember": "Manter sessão iniciada",
 "auth.or": "ou",
 "auth.forgot_title": "Recuperar palavra-passe",
 "auth.forgot_sub": "Informe o seu e-mail e enviaremos um link para redefinir a sua palavra-passe.",
 "auth.forgot_sent": "Se o e-mail existir, receberá um link para redefinir a palavra-passe.",
 "auth.reset_title": "Definir nova palavra-passe",
 "auth.reset_success": "Palavra-passe redefinida com sucesso!",
 "auth.new_password": "Nova palavra-passe",
 "auth.send_link": "Enviar link",
 "dash.greeting": "Olá!",
 "dash.subtitle": "Vamos preparar um Natal inesquecível?",
 "dash.countdown": "Faltam para a Véspera de Natal",
 "dash.days": "dias",
 "dash.hours": "horas",
 "dash.minutes": "min",
 "dash.seconds": "seg",
 "deco.title": "Decore o seu Natal",
 "deco.budget_q": "Quanto pretende gastar com a sua decoração?",
 "deco.up_to": "Até",
 "deco.above": "Acima de",
 "ceia.title": "Monte a sua Ceia de Natal",
 "ceia.guests_q": "Quantas pessoas participarão?",
 "ceia.budget_q": "Qual é o seu orçamento para a ceia?",
 "ceia.style_q": "Que tipo de ceia deseja?",
 "ceia.other": "Outro",
 "ceia.result_title": "A sua Ceia de Natal",
 "ceia.choose_title": "Escolha os pratos da sua ceia",
 "ceia.choose_sub": "Toque numa opção para escolher. Clique em Ver receita para o passo a passo.",
 "ceia.view_recipe": "Ver receita",
 "ceia.selected_count": "{n} selecionado(s)",
 "ceia.no_selection": "Escolha pelo menos um prato para montar a sua ceia.",
 "ceia.course.starters": "Entradas",
 "ceia.course.main": "Prato principal",
 "ceia.course.sides": "Acompanhamentos",
 "ceia.course.dessert": "Sobremesas",
 "ceia.course.drink": "Bebidas",
 "ceia.choose_dish": "Escolher este prato",
 "ceia.remove_dish": "Remover da ceia",
 "ceia.guests": "convidados",
 "ceia.per_person": "pessoa",
 "ceia.price_scaled_hint": "Valores ajustados para {n} convidados (preço da receita ÷ porções × convidados).",
 "ceia.save": "Guardar a minha ceia",
 "ceia.saved": "Ceia guardada!",
 "ceia.saves_title": "As minhas versões guardadas",
 "ceia.saves_hint": "Pode guardar até 3 versões. Clique para ver os pratos.",
 "ceia.saves_empty": "Nenhuma versão guardada ainda.",
 "ceia.saved_items": "Pratos guardados",
 "ceia.saved_tap_hint": "Clique num prato para ver a receita completa.",
 "ceia.estimate_cost": "Estimar custo",
 "ceia.est_label": "Estimativa de gastos",
 "ceia.est_not_configured": "Estimativa de preços indisponível no momento.",
 "ceia.est_priced": "{a} de {b} itens com preço encontrado",
 "ceia.est_note": "Estimativa baseada no preço mediano do Google Shopping para o nome de cada prato.",
 "ceia.saves_full": "Limite de 3 versões guardadas atingido. Elimine um para guardar outro.",
 "ceia.see_others": "Ver outras opções",
 "ceia.swap_title": "Trocar prato",
 "ceia.swap_pick": "Trocar por este",
 "ceia.swap_empty": "Não há outras opções neste estilo.",
 "ceia.over_budget": "Atenção: a estimativa ultrapassa o orçamento desta categoria ({b}) em {v}.",
 "ceia.load_save": "Carregar nos cartões para editar",
 "ceia.save_name_ph": "Nome desta versão (ex.: Ceia da família)",
 "ceia.est_market": "Preços em {c} · mercado {m}",
 "ceia.loaded": "Ceia carregada! Edite os pratos e guarde uma nova versão.",
 "recipes.title": "Receitas de Natal",
 "recipes.all": "Todas",
 "recipes.time": "Tempo",
 "recipes.difficulty": "Dificuldade",
 "recipes.servings": "Porções",
 "recipes.ingredients": "Ingredientes",
 "recipes.steps": "Modo de preparo",
 "recipes.cost": "Custo estimado",
 "recipes.min": "min",
 "diff.easy": "Fácil",
 "diff.medium": "Médio",
 "diff.hard": "Difícil",
 "table.title": "Prepare uma Mesa Inesquecível",
 "shopping.title": "A minha Lista de Compras",
 "shopping.add_ph": "Adicionar item...",
 "shopping.completed": "Concluídos",
 "shopping.empty": "A sua lista ainda está vazia.",
 "shopping.empty_sub": "Adicione itens das receitas ou comece a sua própria lista.",
 "shopping.qty": "Qtd",
 "shopping.cat.decoration": "Decoração",
 "shopping.cat.ceia": "Ceia",
 "shopping.cat.drinks": "Bebidas",
 "shopping.cat.desserts": "Sobremesas",
 "shopping.cat.gifts": "Presentes",
 "shopping.cat.other": "Outros",
 "planner.title": "O meu Planeamento de Natal",
 "planner.progress": "Progresso",
 "gifts.title": "Ideias de Presentes",
 "fav.title": "Os meus Favoritos",
 "fav.empty": "O seu Natal está só a começar 🎄",
 "fav.empty_sub": "Guarde as suas receitas e inspirações favoritas e elas aparecerão aqui.",
 "moment.title": "Antes da ceia, pare por alguns minutos.",
 "moment.text": "O Natal também é tempo de agradecer, estar perto de quem amamos e lembrar aquilo que realmente importa.",
 "moment.listen": "Ouça esta oração com a sua família.",
 "moment.audio_soon": "Áudio em breve",
 "moment.qr": "Aponte a câmera para levar a oração à mesa.",
 "account.title": "A minha Conta",
 "account.language": "Idioma",
 "account.country": "País",
 "account.currency": "Moeda",
 "account.preferences": "Preferências",
 "account.saved": "Alterações guardadas!",
 "admin.title": "Painel Administrativo",
 "admin.users": "Utilizadores",
 "admin.content": "Conteúdos",
 "onboarding.title": "Vamos montar o seu Natal?",
 "onboarding.q_country": "Em qual país está?",
 "onboarding.q_guests": "Quantas pessoas participarão?",
 "onboarding.q_budget": "Quanto pretende gastar?",
 "onboarding.q_style": "Qual estilo de Natal prefere?",
 "onboarding.q_goals": "O que deseja organizar?",
 "onboarding.goal.deco": "Decoração",
 "onboarding.goal.ceia": "Ceia",
 "onboarding.goal.both": "Ambos",
 "onboarding.goal.all": "Tudo",
 "onboarding.finish": "Montar o meu Natal",
 "onboarding.skip": "Saltar por agora",
 "footer.rights": "Todos os direitos reservados.",
 "loading": "A carregar...",
 "added_to_list": "Adicionado à sua lista!",
 "fav_added": "Adicionado aos favoritos",
 "fav_removed": "Removido dos favoritos",
 "ss.confirm_msg": "🎁 {name}, foi convidado(a) para o Amigo Secreto \"{group}\"! Confirme a sua participação e diga qual presente quer:",
 "ss.confirm_intro": "{owner} convidou para o Amigo Secreto \"{group}\". Confirme a sua participação e diga o presente que quer receber.",
 "ss.gift_limit": "Presente até {v}",
 "ss.up_to": "até {v}",
 "ss.wish_label": "Qual presente quer?",
 "ss.wish_ph": "Ex.: Livro do Harry Potter, perfume, fone bluetooth…",
 "ss.wish_link_label": "Link do produto (opcional)",
 "ss.wish_required": "Diga qual presente quer.",
 "ss.confirm_btn": "Confirmo a minha participação",
 "ss.confirm_hint": "Só quem confirmar entra no sorteio. Quem tirar verá este presente.",
 "ss.confirmed_toast": "Participação confirmada! 🎄",
 "ss.confirmed_title": "Está no sorteio!",
 "ss.confirmed_text": "Quando o organizador sortear, receberá por e-mail e WhatsApp um link secreto com o seu Amigo Secreto e o presente que ele quer.",
 "ss.your_wish": "O seu presente",
 "ss.edit_wish": "Alterar presente",
 "ss.confirm_drawn": "O sorteio já foi realizado. Verifique o link secreto que recebeu por e-mail/WhatsApp.",
 "ss.status_confirmed": "Confirmado",
 "ss.status_pending": "A aguardar confirmação",
 "ss.confirmed_count": "{c} de {n} confirmaram participação.",
 "ss.min2_confirmed": "É preciso pelo menos 2 participantes confirmados para sortear.",
 "ss.pending_warning": "Ainda não confirmaram e ficarão FORA do sorteio: {names}. Sortear mesmo assim?",
 "ss.invite_auto_sent": "Convite enviado por e-mail para {name}! Use o botão do WhatsApp para reforçar.",
 "ss.invite_auto_failed": "Participante adicionado, mas o e-mail falhou. Envie o convite pelo WhatsApp.",
 "ss.email_req": "E-mail (obrigatório)",
 "ss.phone_req": "WhatsApp",
 "ss.contact_required": "Preencha nome, e-mail e WhatsApp.",
 "ss.contact_saved": "Contacto atualizado!",
 "ss.missing_contact": "Antes de sortear, complete e-mail e WhatsApp de: {names}",
 "ss.edit_contact": "Editar contacto",
 "ss.email_missing": "sem e-mail",
 "ss.phone_missing": "sem WhatsApp",
 "ss.phone_hint": "Introduza só o número com DDD, ex.: {ex}. O código do país é adicionado automaticamente.",
 "ss.reveal_invalid": "Link inválido ou expirado.",
 "ss.reveal_hello": "Olá, {name}!",
 "ss.reveal_private_hint": "O sorteio foi realizado. Este link é só o seu — ninguém mais vê este resultado.",
 "ss.reveal_keep_secret": "Guarde segredo até o dia da troca! 🎄",
 "ss.reveal_msg": "🎁 {name}, o sorteio do Amigo Secreto \"{group}\" foi realizado! Descubra em segredo quem tirou (link pessoal, não partilhe):",
 "ss.send_reveal_wa": "Enviar resultado",
 "ss.revealed_badge": "Já descobriu",
 "ss.drawn_sent": "Sorteio realizado! 🎄 {n} e-mail(s) com o link secreto enviados.",
 "nav.secretsanta": "Amigo Secreto",
 "journey.title": "Do lado de fora da noite... até o coração da sua casa.",
 "journey.night": "Uma noite de Natal",
 "journey.house": "A casa se acende",
 "journey.living": "A sala ganha vida",
 "journey.tree": "A árvore brilha",
 "journey.table": "A mesa é posta",
 "journey.dinner": "A ceia reúne todos",
 "journey.gifts": "Os presentes esperam",
 "journey.family": "E a família se encontra",
 "features.title": "Explore cada detalhe do seu Natal",
 "ss.title": "Amigo Secreto",
 "ss.subtitle": "Organize o seu Amigo Secreto com toda a família ou amigos, direto aqui.",
 "ss.my_groups": "Os meus Amigos Secretos",
 "ss.create": "Crie o seu Amigo Secreto",
 "ss.create_btn": "Criar Amigo Secreto",
 "ss.new": "Novo grupo",
 "ss.group_name": "Nome do grupo",
 "ss.group_name_ph": "Natal da Família 2026",
 "ss.exchange_date": "Data da troca de presentes",
 "ss.suggested_value": "Valor sugerido do presente",
 "ss.group_message": "Mensagem do grupo",
 "ss.group_message_ph": "Nosso Amigo Secreto será depois da ceia!",
 "ss.include_me": "Vou participar deste grupo",
 "ss.participants": "Participantes",
 "ss.who_participates": "Quem vai participar?",
 "ss.add_participant": "Adicionar participante",
 "ss.participant_name": "Nome",
 "ss.email_opt": "E-mail (opcional)",
 "ss.phone_opt": "Telefone/WhatsApp (opcional)",
 "ss.count": "participantes",
 "ss.count_one": "participante",
 "ss.restrictions": "Restrições do sorteio",
 "ss.restrictions_hint": "Defina quem não pode tirar quem (ex.: casais).",
 "ss.cannot_draw": "não pode tirar",
 "ss.add_restriction": "Adicionar restrição",
 "ss.ready": "Tudo pronto! 🎄",
 "ss.ready_sub": "{n} pessoas participarão deste Amigo Secreto.",
 "ss.draw": "Realizar sorteio",
 "ss.draw_note": "Depois que o sorteio for realizado, cada participante poderá descobrir o seu Amigo Secreto de forma privada.",
 "ss.draw_confirm": "Realizar sorteio",
 "ss.redraw": "Refazer sorteio",
 "ss.redraw_confirm": "Já existe um sorteio. Deseja realmente refazer? Os resultados atuais serão substituídos.",
 "ss.impossible": "Não há sorteio possível com essas restrições. Ajuste as regras.",
 "ss.min2": "Adicione pelo menos 2 participantes.",
 "ss.waiting": "🎁 o seu Amigo Secreto está a esperar...",
 "ss.reveal": "Descobrir quem eu tirei",
 "ss.you_got": "Tirou...",
 "ss.mission": "Agora começa a missão de encontrar o presente perfeito.",
 "ss.find_gift": "Encontrar presente para {name}",
 "ss.find_gift_for": "Encontrar um presente para {name}",
 "ss.not_drawn_yet": "O sorteio ainda não foi realizado.",
 "ss.drawn_badge": "Sorteado",
 "ss.wishlist": "A minha Lista de Desejos",
 "ss.wishlist_hint": "Quem te tirar poderá ver estas sugestões.",
 "ss.wishlist_items": "Sugestões de presentes",
 "ss.wishlist_add_ph": "Ex.: Livro, Perfume, Chocolate...",
 "ss.likes": "O que eu gosto",
 "ss.dislikes": "O que prefiro não receber",
 "ss.save_wishlist": "Guardar lista",
 "ss.wishlist_saved": "Lista guardada!",
 "ss.their_wishlist": "Lista de desejos de {name}",
 "ss.no_wishlist": "Ainda sem sugestões.",
 "ss.invite": "Convidar",
 "ss.invite_link": "Link de convite",
 "ss.copy_link": "Copiar link",
 "ss.link_copied": "Link copiado!",
 "ss.invite_hint": "Cada participante recebe um link para confirmar e dizer o presente que quer. Só quem confirmar entra no sorteio; depois, cada um recebe o seu Amigo Secreto e o presente dele por e-mail e WhatsApp.",
 "ss.countdown": "Faltam {n} dias para o nosso Amigo Secreto 🎄",
 "ss.countdown_today": "É hoje! 🎄",
 "ss.empty": "Ainda não tem nenhum Amigo Secreto.",
 "ss.empty_sub": "Crie um grupo e convide a sua família e amigos.",
 "ss.join_title": "Foi convidado!",
 "ss.join_btn": "Participar",
 "ss.join_msg": "{owner} convidou para o Amigo Secreto \"{group}\".",
 "ss.joined": "Entrou no grupo!",
 "ss.already_claimed": "Este convite já foi utilizado.",
 "ss.organizer": "Organizador",
 "ss.you": "você",
 "ss.share_invite": "Partilhar convite",
 "ss.whatsapp": "WhatsApp",
 "ss.send_email": "Enviar por e-mail",
 "ss.email_sent": "Convite enviado por e-mail!",
 "ss.no_email": "Este participante não tem e-mail registado.",
 "ss.suggestions": "Sugestões de presente para {name}",
 "nav.budget": "O meu Orçamento",
 "plan.title": "O meu Natal",
 "plan.country": "País",
 "plan.guests": "Convidados",
 "plan.style": "Estilo",
 "plan.decoration": "Decoração",
 "plan.ceia": "Ceia",
 "plan.progress": "O seu Natal está {n}% planeado",
 "plan.tasks_done": "{a} de {b} tarefas concluídas",
 "plan.greeting_m": "Bom dia",
 "plan.greeting_a": "Boa tarde",
 "plan.greeting_e": "Boa noite",
 "plan.days_xmas": "Faltam {n} dias para o Natal 🎄",
 "plan.xmas_today": "Feliz Natal! 🎄",
 "plan.edit": "Editar Planeamento",
 "plan.setup": "Personalizar o meu Natal",
 "task.country": "País definido",
 "task.guests": "Convidados definidos",
 "task.deco": "Escolher decoração",
 "task.ceia": "Definir a ceia",
 "task.list": "Montar a lista",
 "task.gifts": "Organizar presentes",
 "task.moment": "Preparar o Momento de Natal",
 "budget.title": "O meu Orçamento de Natal",
 "budget.total": "Orçamento total",
 "budget.planned": "Planeado",
 "budget.distributed": "Distribuído",
 "budget.available": "Disponível",
 "budget.over": "{v} acima do planeado",
 "budget.save": "Guardar orçamento",
 "budget.saved": "Orçamento guardado!",
 "budget.others": "Outros",
 "budget.note": "Valores aproximados. Os preços podem variar conforme cidade, loja, época e disponibilidade.",
 "s2.transition": "Agora vamos transformar essa ideia no seu Natal.",
 "journey.sub_night": "Tudo começa com a expectativa.",
 "journey.sub_living": "Cada detalhe transforma a casa.",
 "journey.sub_table": "Sabores também contam histórias.",
 "journey.sub_family": "Porque o melhor do Natal é estar junto.",
 "l3.title": "E como será o seu Natal?",
 "l3.text": "Conte para o MY CHRISTMAS quem estará consigo, quanto pretende gastar e como imagina essa noite. Nós ajudaremos a organizar cada detalhe.",
 "l3.people": "Quantas pessoas?",
 "l3.people_sub": "Planeie a sua celebração.",
 "l3.budget": "Qual o seu orçamento?",
 "l3.budget_sub": "Organize sem perder o controle.",
 "l3.style": "Qual o seu estilo?",
 "l3.style_sub": "Crie um Natal com a sua cara.",
 "l3.cta": "Criar o meu Natal",
 "recipe.portions": "Porções",
 "recipe.for_guests": "Ajustar para convidados",
 "recipe.scaled_hint": "Quantidades estimadas para {n} pessoas (fator ×{f}).",
 "recipe.base": "Receita base: {n} porções",
 "shopping.market_mode": "Modo Supermercado",
 "shopping.list_mode": "Modo Lista",
 "shopping.market_hint": "Toque para marcar o que já colocou no carrinho.",
 "shopping.all_done": "Tudo no carrinho! 🛒",
 "shopping.consolidated": "Itens repetidos foram unificados.",
 "deco.budget_tool": "Orçamento de Decoração",
 "deco.budget_tool_sub": "Distribua o seu orçamento por categoria. Valores estimados.",
 "deco.set_total": "Orçamento total",
 "deco.distributed": "Distribuído",
 "deco.remaining": "Disponível",
 "deco.over": "Ultrapassou o orçamento em {v}",
 "deco.save_budget": "Guardar no Meu Orçamento",
 "deco.saved": "Decoração guardada no seu orçamento!",
 "deco.saves_title": "As minhas versões guardadas",
 "table.cost_title": "Custo estimado no seu país (Google Shopping)",
 "table.cost_note": "Produtos escolhidos para caber no orçamento da Mesa, com preços reais do mercado {m}.",
 "table.cost_over": "A mesa estimada ({s}) passa {v} do orçamento ({b}).",
 "saves.rename": "Renomear",
 "deco.discard_plan": "Eliminar sem guardar",
 "saves.save_changes": "Guardar alterações",
 "saves.discard": "Descartar",
 "saves.unsaved": "Tem alterações não guardadas.",
 "saves.load": "Carregar no plano para continuar",
 "saves.loaded": "Salvamento carregado! Continue a montar e guarde uma nova versão.",
 "saves.over_total": "Esta versão guardada ({s}) está {v} acima do orçamento atual ({b}). Edite ou elimine itens para ajustar.",
 "saves.find_product": "Buscar produto",
 "saves.swap_item": "Buscar outros e substituir",
 "saves.name_ph": "Nome desta versão",
 "saves.over_budget": "Esta versão guardada ({s}) está {v} acima do orçamento atual ({b}). Edite as quantidades ou elimine itens para ajustar.",
 "saves.remove_item": "Eliminar item",
 "saves.updated": "Salvamento atualizado!",
 "deco.saves_hint": "Pode guardar até 3 versões. Clique para ver os itens.",
 "deco.saves_empty": "Nenhuma versão guardada ainda.",
 "deco.saved_items": "Itens guardados",
 "deco.saves_full": "Limite de 3 versões guardadas atingido. Elimine um para guardar outro.",
 "deco.reset_alloc": "Redistribuir automaticamente",
 "deco.tree_guide_title": "Montagem da árvore passo a passo",
 "deco.auto_hint": "Distribuímos automaticamente com base num Natal equilibrado. Ajuste como quiser.",
 "table.recreate": "Recriar esta mesa",
 "table.hide_items": "Ocultar itens",
 "table.items_title": "Itens para montar",
 "table.add_all": "Adicionar tudo à lista",
 "table.items_added": "Itens adicionados à lista de compras!",
 "gifts.my_plan": "O meu plano de presentes",
 "gifts.plan_this": "Adicionar ao plano",
 "gifts.recipient_ph": "Para quem é este presente?",
 "gifts.status.choose": "Escolher",
 "gifts.status.buy": "Comprar",
 "gifts.status.wrap": "Embrulhar",
 "gifts.planned": "Valor estimado",
 "gifts.plan_empty": "Ainda não adicionou presentes ao seu plano.",
 "gifts.plan_total": "Total estimado",
 "gifts.added_plan": "Presente adicionado ao plano!",
 "gifts.saved_item": "Presente guardado nas Minhas versões guardadas!",
 "gifts.remove": "Remover",
 "gifts.add_manual": "Adicionar presente",
 "budget.subtitle": "Acompanhe o quanto planeja gastar no Natal. Valores são estimativas.",
 "budget.gifts_auto": "Somado automaticamente do seu plano de presentes.",
 "dash.view_budget": "Ver o meu orçamento",
 "prod.suggestions_title": "Sugestões de produtos",
 "deco.ideal_for": "Ideal para quem procura",
 "deco.elements": "Elementos sugeridos",
 "deco.view_style": "Ver estilo",
 "deco.build": "Montar o meu",
 "deco.plan_title": "A sua decoração dentro do orçamento",
 "deco.allocated": "Reservado",
 "deco.see_others": "Ver outras opções",
 "deco.find_real": "Buscar produtos reais",
 "prod.searching": "A procurar as melhores opções para o seu Natal...",
 "prod.none": "Não encontramos opções adequadas neste momento. Tente aumentar o orçamento ou alterar os filtros.",
 "prod.not_configured": "A busca de produtos reais ainda não está ativa. É necessário configurar a integração (SerpApi) com uma chave para exibir produtos, preços e lojas reais.",
 "prod.error": "Não foi possível buscar agora. Tente novamente em instantes.",
 "prod.view": "Ver produto",
 "prod.choose": "Escolher",
 "prod.find": "Encontrar produtos",
 "prod.disclaimer": "Os preços e a disponibilidade são informados pelas lojas/fontes consultadas e podem mudar sem aviso. Confirme as condições no site do vendedor.",
 "table.how_to": "Como montar esta mesa",
 "table.steps_title": "Passo a passo",
 "table.elements_needed": "Elementos necessários",
 "table.guests": "Convidados",
 "table.for_guests": "Para {n} pessoas",
 "table.find_items": "Encontrar itens para esta mesa",
 "table.view": "Ver detalhes",
 "saves.title": "As minhas versões guardadas",
 "saves.hint": "Pode guardar até 3 versões. Clique para ver os detalhes.",
 "saves.empty": "Nenhuma versão guardada ainda.",
 "saves.items": "Itens guardados",
 "saves.save": "Guardar",
 "saves.saved": "Guardado!",
 "saves.full": "Limite de 3 versões guardadas atingido. Elimine um para guardar outro.",
 "saves.items_label": "itens",
 "table.select_hint": "Toque para escolher os itens que vão para a lista",
 "table.add_selected": "Adicionar {n} à lista",
 "share.title": "Partilhar lista",
 "share.whatsapp": "WhatsApp",
 "share.email": "E-mail",
 "share.copy": "Copiar lista",
 "share.copied": "Lista copiada ✓",
 "share.email_to": "E-mail do destinatário",
 "share.email_send": "Enviar por e-mail",
 "share.email_subject": "A minha Lista de Natal — MY CHRISTMAS",
 "share.email_sent": "E-mail enviado!",
 "share.email_error": "Não foi possível enviar o e-mail agora.",
 "share.empty": "Adicione itens antes de partilhar.",
 "gifts.for_whom": "Para quem é o presente?",
 "gifts.budget_q": "Quanto pretende gastar?",
 "gifts.custom": "Personalizado",
 "gifts.why": "Por que pode ser uma boa opção",
 "gifts.suggestions": "Sugestões",
 "gifts.find_real": "Ver produtos reais",
 "gifts.price_any": "Qualquer valor",
 "gifts.up_to": "Até",
 "gifts.above": "Acima de",
 "estimate": "Estimativa",
 "cta.access": "Garantir o meu acesso",
 "cta.access_alt": "Quero aceder ao MY CHRISTMAS",
 "sales.subline": "Planeie, organize e viva um Natal inesquecível num só lugar.",
 "sales.badge": "Acesso à plataforma completa • Funciona no telemóvel, tablet e computador",
 "sales.after_note": "Após a confirmação do pagamento, receberá por e-mail as instruções para ativar o seu acesso.",
 "sales.ready": "Pronto para começar a preparar o seu Natal?",
 "how.title": "Como funciona?",
 "how.s1t": "Escolha o seu acesso",
 "how.s1d": "Clique em \"Garantir o meu acesso\".",
 "how.s2t": "Faça o pagamento",
 "how.s2d": "Será direcionado para nosso checkout seguro, com moeda e formas de pagamento do seu mercado.",
 "how.s3t": "Receba o seu acesso",
 "how.s3d": "Assim que o pagamento for confirmado, recebe um e-mail com as instruções para ativar o seu acesso.",
 "how.s4t": "Prepare o seu Natal",
 "how.s4d": "Entre no MY CHRISTMAS pelo telemóvel ou computador e comece a organizar o seu Natal.",
 "devices.title": "O seu Natal consigo, onde estiver.",
 "devices.text": "Planeie pelo computador e consulte a sua lista, receitas e organização pelo telemóvel quando precisar.",
 "features.title2": "Tudo o que precisa para preparar o seu Natal",
 "checkout.soon_title": "Checkout em breve",
 "checkout.soon": "O checkout de pagamento ainda está a ser configurado. Em breve poderá garantir o seu acesso por aqui.",
 "activate.title": "Criar a minha palavra-passe",
 "activate.sub": "Defina a sua palavra-passe para ativar o seu acesso ao MY CHRISTMAS.",
 "activate.cta": "Criar a minha palavra-passe e entrar",
 "faq.q_buy": "O que estou a comprar?",
 "faq.a_buy": "Está a adquirir acesso à plataforma digital MY CHRISTMAS, com ferramentas para ajudar a planear e organizar diferentes momentos do seu Natal.",
 "faq.q_access": "Como recebo o meu acesso?",
 "faq.a_access": "Após a confirmação do pagamento, enviaremos um e-mail com as instruções para ativar a sua conta e criar a sua palavra-passe.",
 "faq.q_pay": "O pagamento é feito dentro do MY CHRISTMAS?",
 "faq.a_pay": "O pagamento é processado pelo checkout de pagamento configurado para a sua compra.",
 "login.no_access": "Ainda não tem acesso? Conheça o MY CHRISTMAS.",
 "moment.section_title": "Momento de Natal",
 "moment.section_sub": "Antes da ceia, reúna quem ama e reserve alguns minutos para agradecer.",
 "moment.reading_mode": "Modo Leitura",
 "moment.exit_reading": "Sair do modo leitura",
 "moment.share_prayer": "Partilhar oração",
 "nav.world": "Natal pelo Mundo",
 "nav.create": "Criar o meu Natal",
 "create.cta_title": "Criar o meu Natal",
 "create.cta_sub": "Responda algumas perguntas e deixe o MY CHRISTMAS ajudar a organizar cada detalhe.",
 "create.start": "Começar",
 "create.quick_title": "Preciso organizar o meu Natal rápido",
 "create.quick_sub": "Responda algumas perguntas e receba um plano simplificado.",
 "create.quick_go": "Modo rápido",
 "dash.welcome_new": "Bem-vindo ao MY CHRISTMAS",
 "dash.welcome_new_sub": "Vamos preparar o seu Natal?",
 "dash.welcome_back": "Bem-vindo de volta",
 "dash.continue": "Criar o meu Planeamento",
 "dash.now_title": "O que fazer agora",
 "dash.tasks_title": "Próximas tarefas",
 "dash.tools": "Ferramentas",
 "dash.discover": "Descobrir",
 "dash.days_left": "Faltam {n} dias para o Natal 🎄",
 "dash.days_today": "É hoje! Feliz Natal 🎄",
 "dash.taking_shape": "O seu Natal está a tomar forma.",
 "dash.your_plan": "O seu plano automático",
 "dash.block_done": "Etapa concluída",
 "dash.block_over": "Salvamento {v} acima do orçamento",
 "dash.reserved": "Orçamento reservado",
 "dash.edit_plan": "Editar o meu Natal",
 "wiz.title": "Vamos preparar o seu Natal? 🎄",
 "wiz.step": "Etapa {n} de {total}",
 "wiz.q_country": "Onde será o seu Natal?",
 "wiz.q_country_sub": "Isso define moeda, produtos e referências do seu mercado.",
 "wiz.q_language": "Em qual idioma prefere navegar?",
 "wiz.q_guests": "Quantas pessoas vão celebrar consigo?",
 "wiz.q_audience": "Quem estará consigo?",
 "wiz.q_audience_sub": "Opcional — nos ajuda a planear melhor.",
 "wiz.q_budget": "Quanto pretende investir no seu Natal?",
 "wiz.budget_custom": "Ou introduza o valor que vai usar",
 "wiz.budget_over": "O valor está acima do orçado",
 "wiz.q_split": "Quer dividir o seu orçamento?",
 "wiz.split_auto": "Deixe o MY CHRISTMAS sugerir a divisão",
 "wiz.split_manual": "Quero dividir manualmente",
 "wiz.q_style": "Qual Natal combina mais consigo?",
 "wiz.q_haves": "O que já tem em casa?",
 "wiz.q_haves_sub": "Assim não sugerimos comprar o que já possui.",
 "wiz.q_ceia": "Pretende preparar a ceia?",
 "wiz.q_ceia_level": "Que tipo de ceia?",
 "wiz.q_dietary": "Precisamos considerar alguma preferência alimentar?",
 "wiz.q_secretsanta": "Vai ter Amigo Secreto? 🎁",
 "wiz.q_name": "Dê um nome ao seu Natal",
 "wiz.q_name_sub": "Ele vai aparecer no seu painel.",
 "wiz.q_cover": "Escolha uma capa",
 "wiz.name_ph": "Ex.: Natal Feliz",
 "wiz.processing": "Estamos a preparar o seu Natal...",
 "wiz.p1": "A organizar o seu orçamento...",
 "wiz.p2": "A selecionar inspirações...",
 "wiz.p3": "A pensar na sua ceia...",
 "wiz.p4": "A preparar o seu planeamento...",
 "wiz.p5": "A organizar a sua lista...",
 "wiz.ready": "O seu Natal está pronto para começar",
 "wiz.summary": "Resumo do seu Natal",
 "wiz.finish": "Ver o meu Natal",
 "wiz.next": "Continuar",
 "wiz.back": "Voltar",
 "wiz.skip": "Saltar",
 "wiz.guests_other": "Outra quantidade:",
 "wiz.guests_ph": "ex.: 12",
 "wiz.people": "pessoas",
 "wiz.yes": "Sim",
 "wiz.no": "Não",
 "wiz.quick_badge": "Modo rápido",
 "wiz.q_quick_needs": "O que precisa organizar?",
 "split.decoration": "Decoração",
 "split.ceia": "Ceia",
 "split.gifts": "Presentes",
 "split.table": "Mesa",
 "split.others": "Outros",
 "split.total": "Total",
 "world.title": "Natal pelo Mundo",
 "world.sub": "Descubra como diferentes lugares celebram uma das épocas mais especiais do ano.",
 "world.explore": "Explorar",
 "world.back": "Voltar ao mundo",
 "world.decoration": "Decoração",
 "world.food": "Comidas",
 "world.dessert": "Sobremesas",
 "world.tradition": "Tradições",
 "world.table": "Mesa",
 "world.curiosity": "Curiosidades",
 "world.note": "Conteúdo cultural em revisão — apresentado com respeito às muitas formas de celebrar.",
 "surprise.btn": "Surpreenda-me",
 "surprise.title": "Uma sugestão para si",
 "surprise.again": "Ver outra",
 "surprise.see": "Ver",
 "moment.choose": "Escolha uma experiência para viver antes da ceia.",
 "moment.prayer_card": "Oração de Natal",
 "moment.prayer_desc": "Uma oração cristã para ser lida em família.",
 "moment.gratitude_card": "Mensagem de Gratidão em Família",
 "moment.gratitude_desc": "Uma mensagem calorosa, para qualquer família.",
 "moment.open": "Abrir",
 "moment.back_choose": "Escolher outra experiência",
 "sales2.personal_title": "Não existe um único maneira de celebrar o Natal.",
 "sales2.personal_text": "Cada família tem a sua história, o seu orçamento, os seus sabores e as suas tradições. O MY CHRISTMAS ajuda a organizar uma celebração que combine com a sua.",
 "sales2.demo_kicker": "Diga como será o seu Natal.",
 "sales2.demo_help": "O MY CHRISTMAS ajuda a organizar.",
 "sales2.say_country": "País",
 "sales2.say_people": "Pessoas",
 "sales2.say_budget": "Orçamento",
 "sales2.say_style": "Estilo",
 "sales2.langs": "Disponível em 5 idiomas",
 "sales2.styles_title": "Um Natal com a sua cara",
 "sales2.tagline_big": "O seu Natal. À sua maneira.",
 "reset.link_used": "Esta ligação já foi utilizada. Se ainda não definiu a sua palavra-passe, use “Esqueci-me da palavra-passe” no ecrã de início de sessão.",
 "reset.link_expired": "Esta ligação expirou (validade de 7 dias). Use “Esqueci-me da palavra-passe” no ecrã de início de sessão para receber uma nova.",
 "auth.tagline_sub": "Decoração, consoada, prendas, orçamento e planeamento — tudo num só lugar.",
 "sales2.tagline_sub": "Conte-nos como será a sua celebração e o MY CHRISTMAS ajuda a transformar convidados, orçamento e preferências num plano para o seu Natal.",
 "nav.back_home": "Voltar ao início",
 "nav.my_christmas": "O meu Natal",
 "unsaved.title": "Possui alterações que ainda não foram guardadas.",
 "unsaved.continue": "Continuar a editar",
 "unsaved.leave": "Sair sem guardar",
 "nav.family": "Colaboração Familiar",
 "family.title": "Colaboração Familiar",
 "family.subtitle": "Convide a sua família para ajudar a organizar o Natal — cada pessoa com o seu papel.",
 "family.invite_title": "Convidar alguém",
 "family.name": "Nome",
 "family.email": "E-mail",
 "family.name_ph": "Ex.: Jéssica",
 "family.email_ph": "email@exemplo.com",
 "family.role": "Papel",
 "family.scope": "Pode ajudar com",
 "family.scope_hint": "Escolha os módulos que essa pessoa poderá ver e colaborar.",
 "family.send": "Enviar convite",
 "family.sending": "A enviar...",
 "family.list_title": "A sua família",
 "family.empty": "Ninguém convidado ainda. Comece a adicionar alguém acima.",
 "family.status_invited": "Convidado",
 "family.remove": "Remover",
 "family.ss_note": "🔒 As informações do Amigo Secreto nunca são partilhadas com colaboradores.",
 "family.no_plan": "Crie o seu Natal primeiro para poder convidar a sua família.",
 "family.create": "Criar o meu Natal",
 "family.added": "Convite adicionado!",
 "family.removed": "Colaborador removido.",
 "family.role.helper": "Ajudante geral",
 "family.role.desserts": "Sobremesas",
 "family.role.drinks": "Bebidas",
 "family.role.decoration": "Decoração",
 "family.role.gifts": "Presentes",
 "family.tasks_title": "Tarefas partilhadas",
 "family.add_task": "Adicionar tarefa",
 "family.task_ph": "Ex.: Comprar bebidas",
 "family.responsible": "Responsável",
 "family.unassigned": "Sem responsável",
 "family.me": "Eu",
 "family.due": "Prazo",
 "family.status": "Status",
 "family.status.pending": "Pendente",
 "family.status.doing": "Em andamento",
 "family.status.done": "Concluído",
 "family.no_tasks": "Nenhuma tarefa ainda. Adicione a primeira acima.",
 "family.task_added": "Tarefa adicionada!",
 "login.suspended": "O seu acesso está suspenso (compra reembolsada ou cancelada). Fale com o suporte se precisar de ajuda.",
 "login.title": "ENTRAR NO MY CHRISTMAS",
 "login.subtitle": "Já possui acesso? Entre para continuar a organizar o seu Natal.",
 "login.cta": "ENTRAR",
 "login.noaccess_title": "Ainda não tem acesso?",
 "login.noaccess_text": "O acesso ao MY CHRISTMAS é liberado após a confirmação da compra.",
 "login.steps": [
  "Escolha o seu acesso",
  "Faça o pagamento",
  "Receba o e-mail de ativação",
  "Crie a sua palavra-passe e entre no MY CHRISTMAS"
 ],
 "login.buy_cta": "🎄 QUERO ACEDER AO MY CHRISTMAS",
 "login.access_label": "Acesso ao MY CHRISTMAS — Natal 2026",
 "login.one_time": "Pagamento único",
 "login.price_for": "Preço para {country}",
 "login.err_title": "Não encontramos um acesso ativo para este e-mail.",
 "login.err_text": "Verifique o endereço informado ou conheça o MY CHRISTMAS.",
 "login.retry": "Tentar novamente",
 "login.know": "Quero conhecer o MY CHRISTMAS",
 "login.locked": "Muitas tentativas. Tente novamente em alguns minutos.",
 "login.tooltip": "Para quem já possui acesso",
 "create.title": "CRIE A SUA PALAVRA-PASSE",
 "create.sub": "Defina uma palavra-passe para aceder ao seu MY CHRISTMAS.",
 "create.new": "Nova palavra-passe",
 "create.confirm": "Confirmar palavra-passe",
 "create.req_len": "Pelo menos 6 caracteres",
 "create.req_match": "As duas palavras-passe coincidem",
 "create.cta": "CRIAR PALAVRA-PASSE E CONTINUAR",
 "create.mismatch": "As palavras-passe não coincidem.",
 "create.success_title": "A sua palavra-passe foi criada com sucesso. 🎄",
 "create.success_sub": "Tudo pronto! Agora é só entrar e começar a preparar o seu Natal.",
 "create.success_kept": "Palavra-passe criada para {buyer}. Continua autenticado como {current} — a sessão atual foi preservada. Para entrar como comprador, termine a sessão e inicie sessão com o novo e-mail.", "create.success_cta_kept": "Voltar à minha conta",
 "create.success_cta": "ENTRAR NO MY CHRISTMAS",
 "pending.title": "ESTAMOS AGUARDANDO A CONFIRMAÇÃO DO SEU PAGAMENTO",
 "pending.text": "Assim que a confirmação for recebida, enviaremos as instruções de acesso para o seu e-mail.",
 "pending.back": "Voltar ao início",
 "thanks.title": "Pagamento recebido! 🎄",
 "thanks.text": "Obrigado por escolher o MY CHRISTMAS. o seu acesso está a ser liberado e receberá um e-mail em instantes.",
 "thanks.pending_title": "Recebemos o seu pedido!",
 "thanks.pending_text": "O seu pagamento está a aguardar confirmação (boleto ou Pix). Assim que for aprovado, enviaremos o e-mail de acesso.",
 "thanks.step1_title": "Verifique o seu e-mail",
 "thanks.step1_text": "Enviamos uma mensagem com o assunto “O seu acesso ao MY CHRISTMAS está pronto” para o e-mail usado na compra.",
 "thanks.step2_title": "Crie a sua palavra-passe",
 "thanks.step2_text": "Clique em “CRIAR A MINHA PALAVRA-PASSE” no e-mail e escolha uma palavra-passe segura.",
 "thanks.step3_title": "Entre e comece o seu Natal",
 "thanks.step3_text": "Aceda com o seu e-mail e palavra-passe e comece a organizar decoração, ceia, presentes e muito mais.",
 "thanks.spam": "Não encontrou? Verifique a caixa de spam ou promoções. O e-mail pode levar alguns minutos.",
 "thanks.cta": "JÁ CRIEI A MINHA PALAVRA-PASSE — ENTRAR",
 "admin.pay.title": "Pagamentos",
 "admin.pay.desc": "Checkout único global da Monetizze — usado por todos os mercados (/br, /us, /pt, /fr, /es, /it).",
 "admin.pay.provider": "Provedor",
 "admin.pay.url": "URL do checkout global",
 "admin.pay.url_ph": "https://... (link único da Monetizze)",
 "admin.pay.active": "Ativo",
 "admin.pay.validation": "Validação internacional",
 "admin.pay.pending": "Pendente",
 "admin.pay.validated": "Validado",
 "admin.pay.save": "Guardar configuração",
 "admin.pay.saved": "Configuração guardada.",
 "admin.pay.note": "Enquanto a URL estiver vazia ou inativa, os botões de compra mostram \"em breve\". Os mercados abaixo definem apenas o preço exibido — todos usam o mesmo checkout.",
 "budget.table": "Mesa",
 "shopping.price_ph": "Preço",
 "budget.limit": "Orçamento",
 "budget.planned_amt": "Planeado",
 "budget.available2": "Disponível",
 "budget.of": "{p} de {l} planeados",
 "budget.band_warn": "Está próximo do limite do seu orçamento.",
 "budget.band_over": "{v} acima do orçamento.",
 "budget.adjust": "Ajustar orçamento",
 "budget.new_budget": "Novo orçamento",
 "budget.save_new": "Guardar novo orçamento",
 "budget.cancel": "Cancelar",
 "budget.rebalance": "Reequilibrar orçamento",
 "budget.rebalance_desc": "Transfira orçamento entre categorias sem alterar o total.",
 "budget.rebalance_from": "De",
 "budget.rebalance_to": "Para",
 "budget.rebalance_amount": "Valor",
 "budget.rebalance_confirm": "Sim, reequilibrar",
 "budget.rebalance_done": "Orçamento reequilibrado.",
 "budget.rebalance_suggest": "Possui {v} disponíveis em {from}. Deseja transferir {amount} para {to}?",
 "budget.no": "Não",
 "budget.consolidated": "Visão consolidada",
 "balert.title": "⚠️ Atenção ao seu orçamento",
 "balert.title_total": "⚠️ Atenção ao orçamento total",
 "balert.title_both": "⚠️ Atenção ao seu planeamento",
 "balert.intro": "Esta escolha ultrapassa o orçamento que definiu para {cat}.",
 "balert.intro_total": "Esta escolha cabe em {cat}, mas ultrapassa o orçamento total do seu Natal.",
 "balert.intro_both": "Esta escolha ultrapassa dois limites do seu planeamento:",
 "balert.your_budget": "O seu orçamento",
 "balert.already": "Já planeado",
 "balert.this": "Nova escolha",
 "balert.new_total": "Novo total",
 "balert.over_by": "Ficará {v} acima do orçamento.",
 "balert.cat_over": "{cat}: {v} acima do orçamento",
 "balert.total_over": "Natal completo: {v} acima do orçamento",
 "balert.question": "Deseja continuar mesmo assim?",
 "balert.back": "Voltar",
 "balert.adjust": "Ajustar orçamento",
 "balert.continue": "Sim, continuar",
 "alloc.title": "⚠️ Está a aumentar o seu orçamento",
 "alloc.human": "Reservou {old} para {cat}, mas escolheu {new}. São {delta} a mais do que o planeado.",
 "alloc.free_used": "Possui {free} de saldo livre.",
 "alloc.need": "Para manter o seu orçamento total, precisamos redistribuir {v} de outras categorias.",
 "alloc.redistribute": "Redistribuir {v}",
 "alloc.exceed": "Continuar e ultrapassar o orçamento",
 "alloc.cancel": "Cancelar",
 "alloc.from_title": "De onde quer tirar {v}?",
 "alloc.available": "Disponível",
 "alloc.need_lbl": "Precisamos redistribuir",
 "alloc.selected": "Selecionado",
 "alloc.missing": "Falta",
 "alloc.suggest": "✨ Sugerir redistribuição",
 "alloc.confirm_redis": "Confirmar redistribuição",
 "alloc.exceed_title": "Confirmar alteração",
 "alloc.exceed_body": "O seu orçamento reservado para {cat} era {old}. Está a aumentar para {new}, a ficar {delta} acima do planeado.",
 "alloc.aware": "Estou ciente e quero continuar",
 "alloc.back": "Voltar",
 "alloc.confirm": "Confirmar",
 "alloc.freed": "Liberou {v} do seu orçamento.",
 "alloc.done": "Orçamento atualizado.",
 "alloc.set_total_first": "Defina primeiro o orçamento total do seu Natal no Meu Orçamento.",
 "plan.del_b5": "Os seus versões guardadas de Decoração, Ceia, Mesa e Presentes e o orçamento serão apagados",
 "plan.planned_title": "✨ o seu Natal está planeado!",
 "plan.edit_short": "Editar",
 "plan.save": "Guardar o meu Planeamento",
 "plan.saving": "A guardar…",
 "plan.save_and_exit": "Guardar e sair",
 "plan.discard": "Descartar alterações",
 "plan.keep_editing": "Continuar a editar",
 "plan.unsaved_title": "Alterações não guardadas",
 "plan.unsaved_body": "Fez alterações no seu planeamento que ainda não foram guardadas. O que deseja fazer?",
 "plan.editor_title": "Editar Planeamento",
 "plan.editor_sub": "Toque numa etapa para concluí-la. Guarde para atualizar o seu progresso.",
 "plan.provisional": "Progresso provisório",
 "plan.last_update": "Última atualização: {when}",
 "plan.not_saved_yet": "Ainda não guardou o seu planeamento.",
 "plan.open": "Abrir",
 "plan.steps_done": "{done} de {total} etapas concluídas",
 "plan.saved_toast": "Planeamento guardado!",
 "plan.done": "Concluída",
 "plan.todo": "A fazer",
 "plan.na_mark": "Não se aplica",
 "plan.na_applicable": "Marcar como aplicável",
 "plan.na_tag": "Não se aplica",
 "cbud.title": "Orçamento desta categoria",
 "cbud.sub": "Valor reservado para esta categoria, definido no seu orçamento inicial. Para mudar, edite no Meu Orçamento.",
 "cbud.save": "Guardar orçamento",
 "review.yes": "Sim",
 "review.no": "Não",
 "review.ask_body": "O seu orçamento para {cat} é {old}. Está a tentar alterar para {new} — isso representa {delta} a mais. Para manter o seu orçamento total do Natal, precisamos retirar {delta} de outra categoria. O que deseja fazer?",
 "review.act_redistribute": "Redistribuir {v}",
 "review.act_increase": "Aumentar o meu orçamento",
 "review.act_cancel": "Cancelar",
 "review.q2_title": "Quer rever o seu orçamento?",
 "review.q2_body": "Decidiu não retirar {delta} de outra categoria. o seu orçamento de {cat} continua em {old}. Se quiser gastar mais nesta categoria, pode aumentar o orçamento total do seu Natal. Deseja rever o seu orçamento total?",
 "review.keep": "Não, manter o meu plano",
 "review.review": "Sim, rever o meu orçamento",
 "review.total_body": "Tentou aumentar {cat} de {old} para {new}. Para fazer isso sem reduzir outras categorias, o seu orçamento total precisará aumentar em {inc}.",
 "review.current": "Orçamento atual",
 "review.suggested": "Sugestão de novo orçamento",
 "review.new_total_label": "Novo orçamento total",
 "review.min_hint": "O novo total precisa ser ao menos {v}.",
 "review.cancel": "Cancelar",
 "review.confirm_total": "Confirmar novo orçamento",
 "review.total_saved": "Orçamento total atualizado",
 "review.apply_body": "Agora que o seu orçamento foi atualizado, deseja reservar {new} para {cat}?",
 "review.apply_yes": "Sim, aplicar",
 "review.apply_no": "Não",
 "ss.delete_group": "Eliminar grupo",
 "ss.delete_group_q": "Eliminar este grupo de Amigo Secreto?",
 "ss.delete_group_note": "Isso removerá o grupo, os participantes, o sorteio e as listas de desejos. Esta ação não pode ser desfeita.",
 "ss.delete_group_yes": "Sim, eliminar grupo",
 "ss.deleted": "Grupo eliminado",
 "plan.delete": "Eliminar planeamento",
 "plan.del_title": "Eliminar o seu planeamento?",
 "plan.del_body": "Isso apagará o planeamento atual do seu Natal e permitirá que comece novamente do zero.",
 "plan.del_b1": "O seu progresso voltará para 0%",
 "plan.del_b2": "As etapas concluídas serão zeradas",
 "plan.del_b3": "As configurações atuais do planeamento serão removidas",
 "plan.del_b4": "Poderá criar um novo planeamento em seguida",
 "plan.del_sure": "Tem certeza de que deseja eliminar este planeamento?",
 "plan.del_note_account": "Isso não cancela a sua conta, o seu acesso nem a sua compra.",
 "plan.del_ss_note": "Os seus grupos de Amigo Secreto (com participantes ou sorteios) serão preservados.",
 "plan.del_cancel": "Cancelar",
 "plan.del_confirm": "Sim, eliminar e começar novamente",
 "plan.del_deleting": "A eliminar…",
 "plan.del_ok_title": "Planeamento eliminado",
 "plan.del_ok_body": "Pode começar um novo Natal quando quiser. 🎄",
 "plan.del_ok_cta": "Criar o meu Natal",
 "plan.del_err_title": "Não foi possível eliminar",
 "plan.del_err_body": "Não foi possível eliminar o seu planeamento. Tente novamente.",
 "plan.del_retry": "Tentar novamente",
 "ps.confirming_title": "Estamos a confirmar o seu pagamento...",
 "ps.confirming_text": "Isso normalmente leva apenas alguns instantes. Assim que a confirmação chegar, o seu acesso ao My Christmas será liberado.",
 "ps.still_waiting": "A confirmação ainda não chegou. Pagamentos por cartão costumam ser confirmados em minutos; boleto e Pix podem levar mais tempo. Verifique o e-mail usado na compra e tente novamente.",
 "ps.email_ph": "E-mail usado na compra",
 "ps.check_btn": "Verificar",
 "ps.checking_for": "A verificar o pagamento de",
 "ps.approved_title": "🎄 Pagamento recebido!",
 "ps.approved_sub": "O seu My Christmas está quase pronto.",
 "ps.approved_text1": "Enviamos um e-mail para o endereço utilizado na compra.",
 "ps.approved_text2": "Abra esse e-mail e clique em “Criar a minha palavra-passe” para ativar o seu acesso ao My Christmas.",
 "ps.step1": "Verifique o seu e-mail",
 "ps.step2": "Clique em “Criar a minha palavra-passe”",
 "ps.step3": "Escolha a sua palavra-passe",
 "ps.step4": "Entre no My Christmas e comece a planear o seu Natal",
 "ps.not_found": "Não encontrou o e-mail?",
 "ps.not_found_text": "Verifique também as pastas Spam, Lixo eletrónico e Promoções.",
 "ps.resend": "Reenviar e-mail de ativação",
 "ps.resent": "Se houver uma compra aprovada para este e-mail, um novo e-mail foi enviado.",
 "ps.resend_wait": "Aguarde alguns minutos antes de pedir um novo envio.",
 "ps.open_mail": "Abrir o meu e-mail",
 "ps.login": "Entrar no My Christmas",
 "ps.existing_title": "Pagamento confirmado!",
 "ps.existing_text": "O seu acesso ao My Christmas foi atualizado. Entre com a sua conta de sempre.",
 "recipes.typical_by_country": "Típicos por país",
 "recipes.all_countries": "Todos os países",
 "recipes.typical_badge": "Típico",
 "recipes.empty_filter": "Nenhuma receita com estes filtros. Tente outra categoria ou país.",
 "ceia.typical_remove_all": "Desmarcar o menu completo",
 "ceia.typical_removed": "Menu típico removido da sua ceia.",
 "ceia.list_btn": "Gerar lista de compras",
 "ceia.list_title": "Lista de compras",
 "ceia.list_for": "Para {n} convidados · {k} pratos",
 "ceia.list_copy": "Copiar",
 "ceia.list_copied": "Lista copiada!",
 "ceia.list_whatsapp": "Enviar por WhatsApp",
 "ceia.list_download": "Baixar (.txt)",
 "ceia.list_note": "Quantidades ajustadas proporcionalmente às porções de cada receita — valores estimados.",
 "ceia.typical_add_all": "Adicionar o menu completo",
 "ceia.typical_added": "Menu típico adicionado à sua ceia!",
 "ceia.consoada_title": "Consoada Portuguesa",
 "ceia.consoada_sub": "Os pratos típicos da noite de 24 de dezembro em Portugal: bacalhau com todos, rabanadas, bolo-rei e mais.",
 "ceia.consoada_add_all": "Adicionar toda a consoada",
 "ceia.consoada_badge": "Típico de Portugal",
 "ceia.consoada_added": "Consoada adicionada à sua ceia!",
 "cook.open": "Modo Cozinha",
 "cook.step_of": "Passo {n} de {total}",
 "cook.prev": "Anterior",
 "cook.next": "Próximo",
 "cook.finish": "Concluir",
 "cook.done_title": "Receita concluída!",
 "cook.done_body": "Bom apetite e Feliz Natal.",
 "cook.close": "Sair do Modo Cozinha",
 "cook.timer_start": "Iniciar timer de {m} min",
 "cook.timer_custom": "Timer",
 "cook.timer_running": "Timer",
 "cook.timer_pause": "Pausar",
 "cook.timer_resume": "Retomar",
 "cook.timer_reset": "Zerar",
 "cook.timer_done": "Tempo esgotado!",
 "cook.ingredients": "Ingredientes",
 "cook.minutes": "min",
 "cook.hint": "Use as setas ← → do teclado para navegar",
 "psearch.title": "Busque aqui outros itens",
 "psearch.hint": "Introduza o nome do produto e buscamos no Google Shopping as melhores opções",
 "psearch.placeholder": "Ex.: air fryer, grinalda 60 cm, individual de mesa…",
 "psearch.button": "Buscar",
 "psearch.max": "até {v}",
 "bhist.title": "Orçamentos guardados",
 "bhist.hint": "Cada vez que guardada o orçamento, guardamos a data, a hora e o que estava guardado em cada cartão. Clique para ver os detalhes.",
 "bhist.empty": "Nenhum orçamento guardado ainda.",
 "bhist.total": "Total",
 "bhist.planned": "Planeado",
 "bhist.no_saves": "Sem versões guardadas neste cartão na época.",
 "gifts.draft_title": "A sua lista atual",
 "gifts.draft_hint": "Escolha os presentes e clique em Guardar lista para guardar esta versão. Depois pode montar outra lista (até 3).",
 "gifts.save_list": "Guardar lista",
 "gifts.clear_list": "Limpar",
 "gifts.list_saved": "Lista guardada!",
 "gifts.added_to_list": "Adicionado à sua lista",
 "gifts.list_name_ph": "Nome da lista (ex.: Presentes da família)",
 "gifts.saves_full": "Limite de 3 listas atingido. Elimine uma para guardar outra.",
 "psearch.recent": "Recentes",
 "psearch.clear_history": "Limpar histórico",
 "psearch.extra_label": "Item extra",
 "psearch.ceia_added": "Item adicionado à ceia",
 "cbud.spent_label": "Quanto gastou nesta categoria?",
 "cbud.spent_ph": "ex.: 850",
 "cbud.spent_save": "Guardar",
 "cbud.spent_clear": "Limpar",
 "cbud.spent_saved": "Valor gasto guardado. Saldo atualizado no cartão e em O meu Orçamento.",
 "cbud.spent_left": "Saldo disponível: {v}",
 "cbud.spent_over": "Gastou {v} a mais do que o orçamentado.",
 "cbud.spent_of": "Gasto: {s} de {l}",
 "ss.edit_group": "Editar grupo",
 "ss.edit_title": "Editar Amigo Secreto",
 "ss.save_changes": "Guardar alterações",
 "ss.updated": "Grupo atualizado",
 "ss.cancel": "Cancelar",
 "ss.open_group": "Abrir grupo"
};

export const LANDING_PT_PT = {
 "login": "Entrar",
 "hero": {
  "h1a": "O SEU NATAL INTEIRO.",
  "h1b": "ORGANIZADO NUM SÓ LUGAR.",
  "sub": "Decoração, ceia, receitas, presentes, Amigo Secreto e planeamento — personalizados para a sua família, o seu orçamento e o seu país.",
  "cta": "🎄 Criar o meu Natal",
  "cta2": "Veja como funciona",
  "badge": "Acesso à plataforma • 5 idiomas • Telemóvel, tablet e computador",
  "access": "Acesso ao MY CHRISTMAS",
  "oneTime": "Pagamento único • Edição Natal 2026",
  "priceFor": "Preço para {country}"
 },
 "product": {
  "title": "CONHEÇA O SEU MY CHRISTMAS",
  "text": "Uma experiência criada para transformar ideias, convidados, orçamento e preferências num Natal muito mais fácil de organizar."
 },
 "pain": {
  "title": "O NATAL É MARAVILHOSO. ORGANIZAR TUDO NEM SEMPRE É.",
  "questions": [
   "O que servir?",
   "Quanto preparar?",
   "Como decorar?",
   "Quanto gastar?",
   "O que comprar?",
   "Que presente escolher?",
   "Como organizar tudo a tempo?"
  ],
  "bridge": "É por isso que criamos o MY CHRISTMAS.",
  "text": "Em vez de espalhar o seu Natal entre pesquisas, anotações, listas e ideias guardadas, organize a sua celebração num único lugar.",
  "cta": "Começar o meu Natal"
 },
 "demo": {
  "title": "DIGA COMO SERÁ O SEU NATAL.",
  "say": "Conta",
  "help": "O MY CHRISTMAS transforma isso num plano.",
  "arrow": "e o MY CHRISTMAS ajuda a organizar"
 },
 "personal": {
  "title": "NÃO EXISTE UM ÚNICO MANEIRA DE CELEBRAR O NATAL.",
  "text": "Cada família tem a sua história, os seus sabores, as suas tradições e o seu orçamento. Por isso, o MY CHRISTMAS começa a conhecer o seu Natal.",
  "formula": [
   "País",
   "Convidados",
   "Orçamento",
   "Estilo",
   "Preferências"
  ],
  "equals": "= o SEU Natal",
  "cta": "Personalizar o meu Natal"
 },
 "featuresTitle": "TUDO QUE PRECISA PARA ORGANIZAR O SEU NATAL",
 "features": [
  {
   "key": "decoration",
   "title": "🎄 Decore sem estourar o orçamento",
   "text": "Escolha o seu estilo, informe quanto pretende gastar e encontre inspirações para montar a sua decoração."
  },
  {
   "key": "ceia",
   "title": "🍽️ Planeie uma ceia para o número certo de pessoas",
   "text": "Monte o seu menu, ajuste as quantidades e organize o que será necessário para a sua ceia."
  },
  {
   "key": "gifts",
   "title": "🎁 Presentes sem a correria de última hora",
   "text": "Organize para quem comprar, quanto pretende gastar e encontre ideias de presentes."
  },
  {
   "key": "secretsanta",
   "title": "🎅 Amigo Secreto sem papelzinhos",
   "text": "Crie o seu grupo, faça o sorteio e partilhe os convites de forma simples e privada."
  },
  {
   "key": "planner",
   "title": "📅 Saiba o que fazer e quando fazer",
   "text": "Acompanhe o seu planeamento e veja o que merece atenção conforme o Natal se aproxima."
  }
 ],
 "quiz": {
  "cta": "✨ Descubra o seu estilo de Natal",
  "intro": "Responda 3 perguntas rápidas — sem registo.",
  "questions": [
   {
    "q": "Qual cenário combina mais consigo?",
    "opts": [
     [
      "tradicional",
      "Tradicional"
     ],
     [
      "elegante",
      "Elegante"
     ],
     [
      "moderno",
      "Moderno"
     ],
     [
      "rustico",
      "Rústico"
     ],
     [
      "minimalista",
      "Minimalista"
     ]
    ]
   },
   {
    "q": "Qual paleta mais combina com o seu Natal?",
    "opts": [
     [
      "tradicional",
      "Vermelho, verde e dourado"
     ],
     [
      "branco_dourado",
      "Branco e dourado"
     ],
     [
      "moderno",
      "Tons profundos e sóbrios"
     ],
     [
      "rustico",
      "Madeira e tons naturais"
     ],
     [
      "minimalista",
      "Neutros e clean"
     ]
    ]
   },
   {
    "q": "Como imagina a sua celebração?",
    "opts": [
     [
      "rustico",
      "Aconchegante"
     ],
     [
      "elegante",
      "Sofisticada"
     ],
     [
      "divertido",
      "Divertida"
     ],
     [
      "minimalista",
      "Minimalista"
     ],
     [
      "tradicional",
      "Tradicional"
     ]
    ]
   }
  ],
  "resultKicker": "✨ o seu estilo de Natal é:",
  "resultQ": "Quer transformar esse estilo em decoração, mesa, ceia e planeamento?",
  "resultCta": "🎄 Criar o meu Natal",
  "again": "Refazer"
 },
 "receive": {
  "title": "TUDO ISSO DENTRO DO SEU MY CHRISTMAS",
  "items": [
   "Planeamento personalizado",
   "Decoração por estilo e orçamento",
   "Planeamento da ceia",
   "Receitas",
   "Cálculo de quantidades",
   "Mesa de Natal",
   "Planeamento de presentes",
   "Amigo Secreto",
   "Controle de orçamento",
   "Contagem decrescente",
   "Momento de Natal",
   "Natal pelo Mundo",
   "Experiência em 5 idiomas",
   "Acesso pelo telemóvel, tablet e computador"
  ]
 },
 "compare": {
  "title": "MENOS CORRERIA. MAIS TEMPO PARA VIVER O NATAL.",
  "beforeLabel": "Sem organização",
  "withLabel": "Com MY CHRISTMAS",
  "before": [
   "Receitas guardadas em vários lugares",
   "Lista no bloco de notas",
   "Ideias espalhadas",
   "Orçamento perdido",
   "Presentes esquecidos",
   "Compras de última hora"
  ],
  "with": [
   "O seu planeamento",
   "A sua ceia",
   "A sua decoração",
   "Os seus presentes",
   "A sua lista",
   "O seu orçamento"
  ],
  "foot": "Tudo organizado num só lugar."
 },
 "shopping": {
  "h1a": "Planeie em casa.",
  "h1b": "Leve o seu Natal consigo.",
  "text": "Organize tudo com calma e consulte a sua lista pelo telemóvel quando estiver a fazer as suas compras.",
  "cats": [
   "Ceia",
   "Decoração",
   "Mesa",
   "Presentes"
  ],
  "cta": "Criar a minha lista"
 },
 "intl": {
  "title": "O SEU NATAL, ONDE ESTIVER. 🌍",
  "text": "O MY CHRISTMAS foi pensado para diferentes países, idiomas, moedas e formas de celebrar.",
  "note": "Idioma e país são configurações independentes.",
  "langs": [
   "Português",
   "English",
   "Español",
   "Français",
   "Italiano"
  ]
 },
 "world": {
  "title": "🌍 Descubra o Natal pelo Mundo",
  "text": "Conheça sabores, inspirações e tradições encontradas em diferentes lugares do mundo.",
  "cta": "Explorar com o MY CHRISTMAS"
 },
 "emotion": {
  "h1": "No final, o Natal não é sobre organizar coisas.",
  "h2": "É sobre ter mais tempo para viver o que importa.",
  "text": "O MY CHRISTMAS ajuda na organização para que possa dedicar a sua atenção ao que nenhuma lista substitui: estar junto.",
  "prayer": "🙏 Oração de Natal",
  "gratitude": "❤️ Mensagem de Gratidão em Família"
 },
 "how": {
  "title": "COMO FUNCIONA?",
  "steps": [
   [
    "Garanta o seu acesso",
    "Faça a sua compra com segurança."
   ],
   [
    "Ative a sua conta",
    "Após a confirmação do pagamento, recebe as instruções por e-mail."
   ],
   [
    "Conte como será o seu Natal",
    "Informe país, convidados, orçamento, estilo e preferências."
   ],
   [
    "Comece a organizar",
    "Use o seu plano e todas as ferramentas do MY CHRISTMAS."
   ]
  ]
 },
 "offer": {
  "kicker": "O SEU NATAL COMEÇA AQUI.",
  "title": "MY CHRISTMAS",
  "items": [
   "Plataforma completa",
   "Planeamento personalizado",
   "Decoração",
   "Ceia e receitas",
   "Presentes",
   "Amigo Secreto",
   "Orçamento",
   "Momento de Natal",
   "5 idiomas",
   "Acesso em diferentes dispositivos"
  ],
  "priceNote": "Preço configurado para o seu mercado",
  "oneTime": "Pagamento único",
  "cta": "🎄 Quero criar o meu Natal",
  "secure": "Pagamento seguro • Ativação após confirmação da compra"
 },
 "faq": [
  [
   "O que estou a comprar?",
   "Uma plataforma digital para ajudar a organizar diferentes partes do seu Natal."
  ],
  [
   "É um e-book?",
   "Não. O MY CHRISTMAS é uma experiência online interativa."
  ],
  [
   "Preciso instalar aplicação?",
   "Não. A plataforma funciona pelo navegador."
  ],
  [
   "Funciona no telemóvel?",
   "Sim, com interface responsiva."
  ],
  [
   "Quais idiomas estão disponíveis?",
   "Português, inglês, espanhol, francês e italiano."
  ],
  [
   "Posso escolher o meu país separadamente do idioma?",
   "Sim."
  ],
  [
   "Como recebo o meu acesso?",
   "Após a confirmação da compra, recebe por e-mail as instruções para ativar a conta."
  ],
  [
   "O MY CHRISTMAS faz as compras por mim?",
   "Não. A plataforma ajuda a planear e, quando houver integração disponível, poderá indicar onde alguns produtos podem ser encontrados."
  ],
  [
   "Os preços dos produtos são garantidos?",
   "Não. Preços e disponibilidade externos podem mudar e dependem da loja responsável."
  ]
 ],
 "finalCta": {
  "h1": "O Natal acontece uma vez por ano.",
  "h2": "Faça o seu ter a sua cara.",
  "text": "Comece agora a organizar decoração, ceia, presentes, compras e todos os detalhes da sua celebração.",
  "cta": "🎄 Criar o meu Natal",
  "sign": "O seu Natal. À sua maneira."
 },
 "sticky": {
  "cta": "Criar o meu Natal"
 }
};

export const TUTORIALS_PT_PT = {
 "ceia": {
  "title": "Como usar: Monte a sua Ceia de Natal",
  "steps": [
   {
    "title": "1. Verifique o orçamento da Ceia",
    "text": "O cartão “Orçamento desta categoria” mostra o valor reservado para a ceia no “Meu Orçamento”, a soma das “Minhas versões guardadas” e o “Disponível”. À direita ficam as versões guardadas (até 3).",
    "tips": [
     "Se o Disponível ficar vermelho, as suas versões guardadas passaram do orçamento.",
     "Para mudar o valor reservado, edite no “Meu Orçamento”."
    ]
   },
   {
    "title": "2. Passo 1 — Convidados",
    "text": "Informe quantas pessoas vão à ceia. Esse número ajusta as porções e a estimativa de custo.",
    "tips": [
     "Pode voltar e alterar o número a qualquer momento."
    ]
   },
   {
    "title": "3. Passo 2 — Orçamento da ceia",
    "text": "Defina quanto quer gastar na ceia. O sistema usa esse valor para comparar com a estimativa e avisar se passar.",
    "tips": [
     "O valor sugerido vem do seu orçamento por categoria."
    ]
   },
   {
    "title": "4. Passo 3 — Estilo da ceia",
    "text": "Escolha um estilo (Tradicional, Elegante, Económica, etc.). Cada estilo tem um conjunto de pratos sugeridos por curso: entradas, prato principal, acompanhamentos, sobremesas e bebidas.",
    "tips": [
     "Trocar o estilo recarrega os pratos e os preços."
    ]
   },
   {
    "title": "5. Escolha os pratos",
    "text": "Cada cartão de prato mostra tempo de preparo, porções e o custo estimado (~R$) buscado no Google Shopping do seu país. Marque os pratos que quer servir; o total “Estimativa de gastos” soma na hora, no topo e no painel abaixo.",
    "tips": [
     "Clique no cartão para ver a receita completa com ingredientes e modo de preparo.",
     "Dentro da receita, “Ver outras opções” mostra pratos parecidos com preço para trocar.",
     "Se mudar o idioma, os preços são recalculados na moeda e mercado daquele país."
    ]
   },
   {
    "title": "6. Painel “Estimativa de gastos”",
    "text": "Lista cada prato marcado com o preço e uma lixeira para remover. Um aviso vermelho aparece quando a estimativa passa do orçamento da categoria.",
    "tips": [
     "O total mostra quantos pratos já têm preço (ex.: 6/6)."
    ]
   },
   {
    "title": "7. Guardar a sua ceia",
    "text": "Dê um nome à versão (opcional) e clique em “Guardar a minha ceia”: a versão vai para “As minhas versões guardadas” e a seleção é limpa para uma nova.",
    "tips": [
     "Até 3 versões guardadas — elimine uma (lixeira) para liberar espaço.",
     "Renomeie uma versão pelo lápis ao lado do nome."
    ]
   },
   {
    "title": "8. Gira “As minhas versões guardadas”",
    "text": "Clique numa versão para ver os pratos com preço e o total. Clique num prato para abrir a receita e trocá-lo por outro — a versão e o total são atualizados. Use “Carregar nos cartões para editar” para trazer a versão de volta à seleção, ou “WhatsApp” para partilhar a ceia inteira.",
    "tips": [
     "No painel inicial, o cartão Ceia ganha check verde quando há versão guardada e alerta vermelho se alguma estourou o orçamento — clique no alerta para abrir a versão."
    ]
   }
  ]
 },
 "decoration": {
  "title": "Como usar: Decore o seu Natal",
  "steps": [
   {
    "title": "1. Escolha o estilo da sua decoração",
    "text": "Há quatro estilos: Tradicional (vermelho, verde e dourado), Elegante (dourado e branco), Moderno (tons profundos e minimalismo) e Económico (charme a gastar pouco, com ideias faça mesmo). As bolinhas coloridas mostram a paleta de cada um.",
    "tips": [
     "Clique em “Ver estilo” para abrir a paleta completa, os itens essenciais e dicas do estilo.",
     "Pode trocar de estilo a qualquer momento — a sugestão de produtos será montada de novo."
    ]
   },
   {
    "title": "2. Verifique o Orçamento de Decoração",
    "text": "O valor em destaque é o que reservou para decoração no “Meu Orçamento”. Ao lado aparecem “As minhas versões guardadas” (soma das versões guardadas) e “Disponível” (o que ainda cabe). A barra mostra quanto já está planeado.",
    "tips": [
     "Se o Disponível ficar vermelho, as suas versões guardadas passaram do orçamento.",
     "Para mudar o valor reservado, edite no “Meu Orçamento” — este cartão acompanha automaticamente."
    ]
   },
   {
    "title": "3. Monte a sua decoração dentro do orçamento",
    "text": "Abra um estilo em “Ver estilo” e clique em “Montar o meu Natal …” dentro dele. O sistema divide o orçamento entre os itens (árvore, luzes, bolas, grinalda, etc.) e busca produtos reais no Google Shopping do seu país, no seu idioma e moeda, a escolher os que melhor cabem em cada parte.",
    "tips": [
     "O chip no topo do cartão mostra qual estilo foi usado na sugestão.",
     "Cada item mostra loja, preço, quantidade e o link “Ver produto” para comprar."
    ]
   },
   {
    "title": "4. Ajuste a lista à sua maneira",
    "text": "Em cada item pode aumentar ou diminuir a quantidade (− / +), clicar em “Ver outras opções” para trocar por um produto parecido do mesmo tema natalício, ou eliminar o item. O total (Distribuído / Disponível) recalcula na hora.",
    "tips": [
     "Um valor em vermelho indica que aquele item passou do valor reservado para ele.",
     "As opções de troca já vêm filtradas para caber no valor disponível daquele item."
    ]
   },
   {
    "title": "5. Guarde no meu orçamento",
    "text": "Quando gostar da lista, clique em “Guardar no meu orçamento”. A versão vai para “As minhas versões guardadas” (até 3 versões) e o cartão de produtos é limpo para si montar uma lista nova. Se quiser, dê um nome à versão pelo lápis ao lado do nome.",
    "tips": [
     "Enquanto não guardar, a lista montada fica guardada como rascunho ao navegar entre páginas.",
     "Com 3 versões guardadas, elimine uma (lixeira) para liberar espaço."
    ]
   },
   {
    "title": "6. Gira “As minhas versões guardadas”",
    "text": "Clique numa versão para ver os produtos com foto, quantidade e preço. Dentro dela pode ajustar quantidades, trocar ou eliminar itens — as mudanças só valem depois de clicar em “Guardar alterações” (ou “Descartar” para voltar).",
    "tips": [
     "Se o orçamento diminuir e uma versão ficar acima dele, ela aparece em vermelho com um aviso e o valor que excedeu.",
     "No painel inicial, o cartão Decoração ganha um check verde quando há versão guardada e um alerta vermelho se alguma estourou — clique no alerta para abrir a versão direto."
    ]
   },
   {
    "title": "7. Montagem da árvore e dicas",
    "text": "Abaixo dos produtos encontra o passo a passo de montagem da árvore e dicas de decoração para deixar tudo com cara do seu estilo. Use “Ver estilo” nos cartões para ideias faça mesmo, principalmente no Natal Económico."
   }
  ]
 },
 "gifts": {
  "title": "Como usar: Ideias de Presentes",
  "steps": [
   {
    "title": "1. Verifique o orçamento de Presentes",
    "text": "O cartão “Orçamento desta categoria” mostra o valor reservado para presentes no “Meu Orçamento”, a soma das “Minhas versões guardadas” e o “Disponível” (orçamento − versões guardadas). À direita ficam as versões guardadas (até 3), com dia e hora da última alteração.",
    "tips": [
     "Se o Disponível ficar vermelho, os seus presentes guardados passaram do orçamento.",
     "Para mudar o valor reservado, edite no “Meu Orçamento”."
    ]
   },
   {
    "title": "2. Para quem é o presente?",
    "text": "Escolha o perfil (Para ela, Para ele, Crianças, Pais…) e, se quiser, um teto de preço (Até R$ 50, R$ 100… ou Personalizado). As sugestões mudam conforme o filtro.",
    "tips": [
     "Vindo do Amigo Secreto, o nome da pessoa já aparece como destinatário."
    ]
   },
   {
    "title": "3. Escolha um produto real",
    "text": "Em cada sugestão clique em “Ver produtos reais”: abrem até 10 opções do Google Shopping do seu país, de marcas e lojas diferentes, com foto, preço, loja e avaliação. Clique em “Escolher” no produto que gostou.",
    "tips": [
     "“Ver produto” abre a loja em outra aba sem guardar nada."
    ]
   },
   {
    "title": "4. Monte a lista e guarde",
    "text": "Ao escolher, o presente entra na “Sua lista atual” com preço, foto, loja e link. Ajuste destinatário, quantidade e valor, dê um nome e clique em “Guardar lista”. A lista vai para “As minhas versões guardadas” e pode começar outra (até 3).",
    "tips": [
     "Renomeie a versão pelo lápis ao lado do nome.",
     "Até 3 versões — elimine uma (lixeira) para liberar espaço."
    ]
   },
   {
    "title": "5. Quantidade, preço e destinatário",
    "text": "Clique na versão para abrir os presentes. Em cada item use − / + para a quantidade, edite o preço e clique no destinatário para trocar para quem é o presente. O total (preço × quantidade) e o Disponível atualizam na hora.",
    "tips": [
     "A foto e o ícone de link abrem a loja para comprar."
    ]
   },
   {
    "title": "6. Substituir ou eliminar",
    "text": "A lupa num item busca outros produtos parecidos; ao “Escolher”, ele substitui o item a manter destinatário e quantidade. A lixeira remove o presente da versão.",
    "tips": [
     "No painel inicial, o cartão Presentes ganha check verde quando há versão guardada e alerta vermelho se alguma estourou o orçamento."
    ]
   }
  ]
 },
 "table": {
  "title": "Como usar: Prepare uma Mesa Inesquecível",
  "steps": [
   {
    "title": "1. Verifique o orçamento da Mesa",
    "text": "O cartão “Orçamento desta categoria” mostra o valor reservado para a mesa no “Meu Orçamento”, a soma das “Minhas versões guardadas” e o “Disponível”. À direita ficam as versões guardadas (até 3), com nome, data e valor.",
    "tips": [
     "Valor em vermelho = a versão passou do orçamento.",
     "Renomeie uma versão pelo lápis ao lado do nome."
    ]
   },
   {
    "title": "2. Escolha o número de convidados",
    "text": "Selecione quantas pessoas vão sentar à mesa. Pratos, talheres, taças e guardanapos são calculados por pessoa; trilho, velas e centro de mesa são fixos."
   },
   {
    "title": "3. Escolha o estilo",
    "text": "Tradicional (vermelho e verde), Elegante (dourado e branco), Rústica (madeira e linho) ou Moderna (minimalista). Clique no cartão para abrir o guia completo do estilo.",
    "tips": [
     "Cada estilo muda as cores e as palavras-chave da busca de produtos."
    ]
   },
   {
    "title": "4. Custo estimado no seu país",
    "text": "Ao abrir o estilo, o sistema divide o orçamento entre os itens e busca produtos reais no Google Shopping do seu país (idioma e moeda locais), a escolher os que melhor cabem em cada parte. O total fica vermelho se passar do orçamento.",
    "tips": [
     "Cada item mostra foto, loja, preço unitário, quantidade e link “Ver produto”.",
     "Mudar o número de convidados recalcula tudo."
    ]
   },
   {
    "title": "5. Ajuste os itens",
    "text": "Em cada item use − / + para a quantidade, “Ver outras opções” para trocar por um produto parecido (já filtrado para caber no valor do item) ou a lixeira para eliminar. O total recalcula na hora."
   },
   {
    "title": "6. Guarde a sua mesa",
    "text": "Clique em “Guardar” para guardar a versão nas “Minhas versões guardadas” com os produtos, quantidades e custo. Até 3 versões — elimine uma (lixeira) para liberar espaço."
   },
   {
    "title": "7. Edite uma versão guardada",
    "text": "Clique na versão para ver os produtos com foto e quantidade. Ajuste quantidades, troque ou elimine itens; as mudanças só valem depois de “Guardar alterações” (ou “Descartar”).",
    "tips": [
     "No painel inicial, o cartão Mesa ganha check verde quando há versão guardada e alerta vermelho se alguma estourou — clique no alerta para abrir a versão."
    ]
   }
  ]
 }
};
